import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError } from 'rxjs';
import { HeaderType, StorageKeys } from '../shared/enums/enums';
import { StorageService } from '../shared/services/storage.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const storageService = inject(StorageService);
  const router = inject(Router);
  const headerType = req.params.get('headerType');
  if (headerType) {
    const params = req.params.delete('headerType');
    if (headerType === HeaderType.ACCESS) {
      return next(
        req.clone({
          params: params,
          setHeaders: {
            Authorization: `${
              storageService.getItem(StorageKeys.authTokens).accessToken
            }`,
          },
        })
      ).pipe(
        catchError((error) => {
          if (error?.error?.statusCode === 401) {
            storageService.clearStorage();
            router.navigate(['/login']);
          }
          throw error;
        })
      );
    }
  }
  return next(req);
};
